import dayjs from "dayjs";
import { getDueDatePart } from "./dueDateTime";
import { isPlaceholderEvent } from "./eventPlaceholder";

/**
 * Open events for calendar-style lists: start calendar day is today or later,
 * plus placeholder events (no date required) so they can be advertised.
 * Uses {@link getDueDatePart} so UTC date-only storage matches Event Calendar and task due-date rules.
 * Placeholders sort after dated events.
 */
export function getUpcomingEventsSorted(events) {
  const today = dayjs().format("YYYY-MM-DD");
  const dated = [];
  const placeholders = [];
  for (const ev of events || []) {
    if (isPlaceholderEvent(ev)) {
      placeholders.push(ev);
      continue;
    }
    if (ev.start_datetime && getDueDatePart(ev.start_datetime) >= today) {
      dated.push(ev);
    }
  }
  dated.sort((a, b) => new Date(a.start_datetime) - new Date(b.start_datetime));
  placeholders.sort((a, b) =>
    String(a.name || "").localeCompare(String(b.name || ""), undefined, { sensitivity: "base" })
  );
  return dated.concat(placeholders);
}

/**
 * Prefer an event whose start calendar day is today; otherwise the first in {@link getUpcomingEventsSorted} order.
 */
export function pickDefaultUpcomingEvent(upcomingSorted) {
  const list = upcomingSorted || [];
  if (list.length === 0) return null;
  const today = dayjs().format("YYYY-MM-DD");
  const todayFirst = list.find(
    (ev) => ev.start_datetime && getDueDatePart(ev.start_datetime) === today
  );
  return todayFirst || list[0];
}
